module.exports = __webpack_public_path__ + "img/ico-completed-on.f42d5f03.svg";